/*
 * @Author: Merlin
 * @Date: 
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-10 14:14:29
 * @Description: 这里保存常量
 */
import defaultAvatar from '@/assets/imgs/avatars/animal_01.webp';

// ↓ 站点名称
export const sSiteName = 'BetCorgi';

// ↓ 平台的代币的名称，声明一个常量在此供调用和对比判断。以便于后续维护变更 
export const sCorgiCoin = 'corgi';

// ↓ 前后端传递 token 值的键名
// ↓ 下方的 tk 是 token 的缩写，有意隐晦地将此属性记录到浏览器 
// ↓ 同时用于 <input type="hidden" /> 的 id 值
export const sTokenKey = 'tkValue';

// ↓ 这是 1px x 1px 完全透明的 gif 图片  
export const emptyPic = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';

// ↓ 如果一个地址起始起此字符，则说明是前端项目中的图像 
// ↓ 最好不要轻易修改，否则引起出错 
export const sDefaultAvatarPrefix = 'defaultAvatarName:';
export const sDefaultAvatarURL = defaultAvatar; // 默认头像 

// ↓ 用于 <Popper></Popper>
export const oPopperStyle = {
    '--popper-theme-border-radius': '8px',
    '--popper-theme-padding': '8px 12px',
    '--popper-theme-background-color': '#202A39', 
    '--popper-theme-background-color-hover': '#202A39', 
    '--popper-theme-box-shadow': '3px 6px 9px rgba(0, 0, 0, 0.35)',
};

const days = ['周日','周一','周二','周三','周四','周五','周六'];
const months = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月' ];

// ↓ 日历控件中文语言包
export const oQdateLocale = {
    days, /* starting with Sunday */
    daysShort: days,
    months,
    monthsShort: months,
    firstDayOfWeek: 1, // 0-6, 0 - Sunday, 1 Monday, ...
    format24h: true,
    pluralDay: '天', 
};
